import { render } from "./ObjectsSearch.vue?vue&type=template&id=00a9076a&scoped=true"
import script from "./ObjectsSearch.vue?vue&type=script&lang=js"
export * from "./ObjectsSearch.vue?vue&type=script&lang=js"

import "./ObjectsSearch.vue?vue&type=style&index=0&id=00a9076a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00a9076a"]])

export default __exports__